export default async function updateDownloadPercentage(
  res: Response,
  callback: (percentageProcessed: number) => void
) {
  const contentLength = Number(res.headers.get('Content-Length'))
  let processedLength = 0
  const chunks = []
  if (res.body) {
    const reader = res.body.getReader()
    while (true) {
      const { done, value } = await reader.read()
      if (done) {
        break
      }

      chunks.push(value)
      processedLength += value.length
      const percentageProcessed = +((processedLength / contentLength) * 100).toFixed(0)
      if (percentageProcessed % 10 === 0) {
        callback(percentageProcessed)
      }
    }
  }
  const allChunks = new Uint8Array(processedLength)
  let position = 0
  for (const chunk of chunks) {
    allChunks.set(chunk, position)
    position += chunk.length
  }

  return allChunks.buffer
}
